import React from 'react';
import { FaTelegram } from 'react-icons/fa';
import styles from './style.module.scss';

const TELEGRAM_URL = 'https://telegram.me/soff_uz';

const TelegramWidget = () => {
    const handleTelegramClick = () => {
        window.open(TELEGRAM_URL, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className={styles.telegramWidget}>
            <button
                className={styles.telegramButton}
                onClick={handleTelegramClick}
                aria-label="Telegram kanaliga o'tish"
            >
                <FaTelegram className={styles.telegramIcon} />
            </button>
        </div>
    );
};

export default TelegramWidget;
